export default __webpack_public_path__ + "static/media/logo.0d732338.png";